"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COW_DragonWhelp_KindleAbilityHandler = exports.COW_DragonWhelp_KindleActorAbilityFactory = exports.COW_DragonWhelp_KindleAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
class COW_DragonWhelp_KindleAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.COW_DragonWhelp_Kindle;
        this.__typeName = "COW_DragonWhelp_Kindle";
    }
}
exports.COW_DragonWhelp_KindleAbilityArgs = COW_DragonWhelp_KindleAbilityArgs;
let COW_DragonWhelp_KindleActorAbilityFactory = class COW_DragonWhelp_KindleActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("COW_DragonWhelp_Kindle", "AllAllies", 4);
    }
};
COW_DragonWhelp_KindleActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("COW_DragonWhelp_Kindle")
], COW_DragonWhelp_KindleActorAbilityFactory);
exports.COW_DragonWhelp_KindleActorAbilityFactory = COW_DragonWhelp_KindleActorAbilityFactory;
let COW_DragonWhelp_KindleAbilityHandler = class COW_DragonWhelp_KindleAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(targetId => container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.CriticalStrikeChance, 10),
                        new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Haste, 25)
                    ], false)
                }));
            }
        });
    }
};
COW_DragonWhelp_KindleAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.COW_DragonWhelp_Kindle)
], COW_DragonWhelp_KindleAbilityHandler);
exports.COW_DragonWhelp_KindleAbilityHandler = COW_DragonWhelp_KindleAbilityHandler;
